export default __webpack_public_path__ + "static/media/qi-retired.a2c02dac.jpg";